import { getAppApiRoutes } from "../../Global";
import { DeviceNeedAddRequestModel, DeviceNeedFilterRequestModel } from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class DeviceRequestService {
  async addDeviceRequest(data: DeviceNeedAddRequestModel): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.deviceRequest.addDeviceRequest, data as unknown as Record<string, unknown>);
  }

  async getDeviceRequests(data: DeviceNeedFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.deviceRequest.getDeviceRequests, { orderBy: "createdAt_desc", filter: data });
  }
}

const service: DeviceRequestService = new DeviceRequestService();
export default service;
